<template>
  <label class="switch" :class="{ disabled: disabled }">
    <input type="checkbox" v-model="val" @change="toggle" :disabled="locked || disabled" />
    <span class="slider slider--lock" v-if="locked">
      <span class="text typo-body2">
        <slot name="locked">{{ $t("upperCase.locked") }}</slot>
      </span>
    </span>
    <span class="slider" :class="toggleClass" v-else>
      <span class="text typo-body2">
        <!-- <slot name="on" v-if="val">{{$t("upperCase.on")}}</slot>
        <slot name="off" v-else>{{$t("upperCase.off")}}</slot>-->
      </span>
    </span>
  </label>
</template>

<script>
export default {
  name: "Toggler",
  props: {
    value: Boolean,
    locked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: false
      // locked: false
    };
  },
  computed: {
    toggleClass() {
      return this.val ? "on" : "off";
    }
  },
  watch: {
    value(newV) {
      if (this.val != newV) this.val = newV;
    }
  },
  created() {
    this.val = this.value;
  },
  methods: {
    toggle() {
      this.$emit("input", this.val);
    }
  }
};
</script>

<style lang="scss" scoped>
$width: 28px;
$height: 14px;
$padding: 1px;

.switch {
  position: relative;
  display: inline-block;
  width: $width;
  height: $height;

  input {
    display: none;

    &:checked {
      & + .slider:not(.slider--lock) > .text {
        transition: all 0.2s;
        right: calc(32px + 13px);
        right: $height - $padding;
        left: auto;
      }

      & + .slider:not(.slider--lock):before {
        content: "";
        background-color: #ffffff;
        // transform: translate($width - $height, -50%);
      }
    }
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: $cPrimary;
    transition: 0.2s;
    border-radius: 29px;
    user-select: none;
    box-shadow: 0px 7px 64px rgba(0, 0, 0, 0.1);

    &:before {
      position: absolute;
      content: "";
      height: $height - $padding * 2;
      width: $height - $padding * 2;
      right: 1px ;
      background-color: #ffffff;
      border-radius: 50%;
      transition: all 0.2s;
      top: 1px;
    }

    &.off {
      background-color: $dark9;
      &:before {
        left: 1px;
      }
    }

    > .text {
      position: absolute;
      color: $grey2;
      transition: all 0.2s;
      right: 0;
      width: $width - $height + $padding;
      text-align: center;
      top: calc(40% - 5px);
      bottom: auto;
      font-size: 14px;
      user-select: none;
    }
  }

  .slider--lock {
    &:before {
      font-family: "gemicon" !important;
      line-height: 1;
      /* Better Font Rendering =========== */
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      @include flex-center;
      font-size: 16px;
      content: "\e915";
      background: $bg;
    }
  }

  &.disabled {
    opacity: 0.8;
    pointer-events: none;

    .slider {
      background-color: #e2e2e2 !important;
    }
  }
}
</style>
